import { Injectable, OnDestroy, inject } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { IInfoTableSearchCriteria, ISearchCriteria } from "@tylertech/tyler-api-types";


import { DataSearchService } from "./dataSearchService.g";

@Injectable()
export class DataLoadService<TItem = unknown>
    implements OnDestroy
{
    private readonly $dataSearchService = inject<DataSearchService<TItem>>(DataSearchService);
    private readonly activatedRoute = inject(ActivatedRoute);

    private readonly destructor$ = new Subject<void>();
    private readonly searchParams = new Map<string, string>();

    constructor()
    {
        this.activatedRoute.queryParamMap
            .pipe(takeUntil(this.destructor$))
            .subscribe((paramMap: ParamMap) =>
            {
                this.searchParams.clear();

                paramMap.keys.forEach((key: string) =>
                {
                    this.searchParams.set(key, paramMap.get(key));
                });
            });
    }

    ngOnDestroy(): void
    {
        this.destructor$.next();
        this.destructor$.complete();
    }

    GetFacetTotals(criteria: ISearchCriteria<TItem>): Promise<ISearchCriteria<TItem>>
    {
        criteria.SearchResult = null;
        criteria.TotalHits = 0;
        return this.$dataSearchService.GetFacetTotals(criteria);
    }

    private addBaseAggregateToCriteria(criteria: ISearchCriteria<TItem>): void
    {
        if (!this.searchParams.size)
        {
            return;
        }

        if (this.searchParams.has("AggregateProviderId"))
        {
            criteria.AggregateProviderId = this.searchParams.get("AggregateProviderId");
        }

        if (this.searchParams.has("AggregateId"))
        {
            criteria.AggregateId = this.searchParams.get("AggregateId");
        }
        if (this.searchParams.has("AggregateType"))
        {
            criteria.AggregateType = this.searchParams.get("AggregateType");
        }
    }

    getTableData(criteria: ISearchCriteria<TItem>, size: number, from: number): Promise<IInfoTableSearchCriteria>
    {
        criteria.From = from;
        criteria.Size = size;
        criteria.SearchResult = null;
        criteria.TotalHits = 0;
        this.addBaseAggregateToCriteria(criteria);
        criteria.Settings["DataOnly"] = true;
        return this.$dataSearchService.TableViewData(criteria);
    }

    search(criteria: ISearchCriteria<TItem>, size: number, from: number): Promise<ISearchCriteria<TItem>>
    {
        criteria.From = from;
        criteria.Size = size;
        criteria.SearchResult = null;
        criteria.TotalHits = 0;
        this.addBaseAggregateToCriteria(criteria);
        criteria.Settings["DataOnly"] = false;
        return this.$dataSearchService.Search(criteria);
    }
}
